import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202948",
      "fill-rule": "evenodd",
      d: "M8.1.76H1.519a.76.76 0 0 0-.76.759v11.845c0 .419.34.759.76.759h9.112c.42 0 .76-.34.76-.76V3.798H9.998A1.9 1.9 0 0 1 8.1 1.898zm4.05 2.657v9.947c0 .838-.68 1.518-1.519 1.518H1.52C.68 14.882 0 14.202 0 13.364V1.519C0 .68.68 0 1.519 0h6.96zm-1.522-.38L8.859 1.392v.507c0 .63.51 1.14 1.14 1.14z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#202948",
      "fill-rule": "evenodd",
      d: "M2.914 7.847c0-.21.17-.38.38-.38h5.569a.38.38 0 1 1 0 .76h-5.57a.38.38 0 0 1-.379-.38M2.914 9.872c0-.21.17-.38.38-.38h5.569a.38.38 0 1 1 0 .76h-5.57a.38.38 0 0 1-.379-.38M2.914 5.822c0-.21.17-.38.38-.38h5.569a.38.38 0 1 1 0 .76h-5.57a.38.38 0 0 1-.379-.38",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }